import React from 'react';
import DocumentPage, {
  Section,
  Paragraph,
  DoDoNot,
} from './DocumentPage';

const PortableGasSpaceHeatersDoc = ({ onReturnHome }) => (
  <DocumentPage
    pageTitle="Portable Gas Space Heaters – Safe System of Work"
    documentHeading="Safe System of Work: Safe Use of Gas-Powered Portable Space Heaters"
    meta={[
      ['Document Reference', 'PVS-SSOW-PGH'],
      ['Version', '1.0'],
      ['Date of Issue', '17th March 2026'],
      ['Next Review Date', '17th March 2028'],
      ['Activity', 'Use of gas-powered portable space heaters'],
      ['Review Period', '24 months'],
    ]}
    acknowledgment={{
      documentName: 'Portable Gas Space Heaters – Safe System of Work',
      documentReference: 'PVS-SSOW-PGH',
      processActivity: 'Use of Gas-Powered Portable Space Heaters',
      versionNumber: '1.0',
      dateOfIssue: '17th March 2026',
    }}
    onReturnHome={onReturnHome}
  >
    <Section number="1" title="Introduction">
      <Paragraph>
        Using mobile space heaters can present a number of hazards. The key danger is the increased
        risk of burns, fire or explosion if these are not used properly.
      </Paragraph>
      <Paragraph className="mt-3">
        It should also be noted that some insurance policies will stipulate that mobile type space
        heaters are not used. If in doubt check with your insurance company / broker. Even if their
        use is not prohibited, insurance claims for damage to property caused as a result of fire or
        explosion may be rejected if the company or an employee fails to fulfil any of the following
        conditions.
      </Paragraph>
    </Section>

    <Section number="2" title="Safe System of Work">
      <DoDoNot
        doItems={[
          'Ensure gas cylinders are positioned behind the unit, well away from the heat.',
          'Ensure pre-use checks are carried out before switching on / starting the heater.',
          'Ensure heaters are kept clear of combustible materials.',
          'Maintain a clear space of at least 1 metre to the sides and rear of portable space heaters. A clear space of no less than 2.5m should be provided at the front of the unit.',
          'Ensure that all portable heaters are used in well ventilated areas to help prevent the build-up of fumes and gases.',
          'Switch off heaters when the premises are unattended.',
          'Keep children and animals away from heaters at all times.',
          "Ensure heaters are maintained in line with the manufacturer's instructions.",
        ]}
        doNotItems={[
          'Use gas or liquid powered heaters in a domestic environment e.g. living or sleeping accommodation.',
          'Attempt to modify or alter heaters in any way. Servicing should only be carried out by competent engineers.',
          'Operate portable heaters unless you are familiar with the operating and local emergency procedures.',
          'Use in environments where flammable vapours may be present or if a high dust content is present.',
          'Place portable space heaters where they are liable to be overturned or suffer mechanical damage.',
          'Place portable space heaters on combustible surfaces.',
          'Attempt to replace gas cylinders unless authorised to do so.',
          'Refill, replenish, move or handle gas or liquid powered heaters while they are alight, nor for a period of 30 minutes after the heater has been switched off.',
          'Direct the heater towards cylinders in order to de-ice them.',
          'Use in wet areas or in areas below ground level.',
        ]}
      />
    </Section>

    <Section number="3" title="Reminder">
      <Paragraph className="font-semibold">
        IF YOU HAVE ANY QUESTIONS PLEASE ASK YOUR MANAGER OR SUPERVISOR. You have a duty not only
        to protect your own health and safety but also to ensure that your actions do not put others
        around you at risk.
      </Paragraph>
    </Section>
  </DocumentPage>
);

export default PortableGasSpaceHeatersDoc;
